import React, { useContext, useMemo } from 'react'

import {
    uploadFieldParser,
    uploadInputSelector,
} from '../../../../utils/form/formFieldParser'
import { DataContext } from '../DataContext'
import SectionWrapper from './SectionWrapper'

export default ({ config, title, subtitle }) => {
    const { viewOnly, submissionState, formType, formMethods, isDisabledBasedOnGEM, } = useContext(DataContext)
    const formWidth = 'full'
    const backgroundColorClass = ''
    
    const fields = useMemo(() => {
        let viewOnly = !!(isDisabledBasedOnGEM)
            
        return uploadFieldParser(
            config,
            formWidth,
            null,
            backgroundColorClass,
            uploadInputSelector,
            viewOnly,
        )
    }, [config, viewOnly, submissionState, formMethods, formType])
    return (
        <SectionWrapper title={title} subtitle={subtitle}>
            <div className="formWrapper">{fields}</div>
        </SectionWrapper>
    )
}
